import { Column } from '@access-erp/common';
import { useMemo } from 'react';

import { goToRouteBySearch } from '@/components/common/EnquiriesScreen/utils/goToRouteBySearch';
import { useGetredirectLink } from '@/components/common/EnquiriesScreen/utils/useGetRedirectLink';
import { getHeaderColumns } from '../columns/headerColumns';
import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<any>[];
}

export const useColumns = (): UseTransactionTableColumnsReturn => {
  const getRedirectLink = useGetredirectLink();

  const goToContract = (contractId: string, rowIndex: number, searchString?: string) => {
    const link = getRedirectLink(window.location.pathname, contractId, searchString, rowIndex);
    browserHistory.push(getParameterizedLink(link));
  };

  const goToContractsBySearch = (searchText?: string) => {
    goToRouteBySearch(searchText);
  };
  return useMemo(() => {
    const headerColumns = getHeaderColumns({ goToContract, getRedirectLink });

    return {
      headerColumns,
      goToContractsBySearch,
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
